export const GetAllBeds = async (resource) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/bed`)
        .then(
            (response) => {
                result = response.body.beds
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}
export const GetBed = async (resource, id) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/bed/${id}`)
        .then(
            (response) => {
                result = response.body.bed
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const PutBed = async (resource, id, data) => {
    let result
    await resource
        .put(`api/${localStorage.getItem('perfil')}/bed/${id}`, data)
        .then(
            (response) => {
                result = response.body.beds
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}
export const BedFindByStablishmentSubCatId = async (resource,stablishment_id,subcat_id) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/bed/find_by_stablishment_id_and_subcategorization_id/${stablishment_id}/${subcat_id}`)
        .then(
            (response) => {
                result = response.body.bed
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}
export const BedFindByStablishmentSubCatIdNotEliminada = async (resource,stablishment_id,subcat_id) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/bed/find_by_stablishment_id_and_subcategorization_id_state1/${stablishment_id}/${subcat_id}`)
        .then(
            (response) => {
                result = response.body.bed
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}
export const PostBed = async (resource, data) => {
    let result
    await resource
        .post(`api/${localStorage.getItem('perfil')}/bed`, data)
        .then(
            (response) => {
                result = response.body.beds
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}